// Copyright (c) 2017 Deere & Company

import './customer-search-field.scss';
import React, {PropTypes} from 'react';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerSearch2Modal from '../../../shared/components/customer-search-2/customer-search-2-modal';
import {FormattedMessage} from 'react-intl';

/* eslint-disable complexity */

const CustomerSearchField = props =>
    <div className='form-group customer-search-field required'>
        <label>
            <FormattedMessage id='CUSTOMER'/>
        </label>
        {props.isCustomerEditable ?
            <div>
                <div>
                    {props.customer.displayName ?
                        <span className='customer-name'>
                            {props.customer.displayName}
                        </span> : null
                    }

                    {props.showCustomerSearchIcon && props.customer.displayName ?
                        <span
                            className='icon-search'
                            onClick={props.onCustomerSearchClick}
                            onKeyPress={props.onCustomerKeyPress}
                            role='button'
                            tabIndex='2'
                        /> :
                            <button
                                className='customer-search'
                                onClick={props.onCustomerSearchClick}
                                tabIndex='2'
                            >
                                <span className='icon-search-small'/>
                                <FormattedMessage id='CUSTOMER_SEARCH'/>
                            </button>
                    }
                </div>
                {props.isMachineAlreadyRegistered &&
                <span className='machine-registered-message'>
                    <FormattedMessage id='MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER'/>
                </span>
                }
                {props.isCustomerInvalid &&
                <span className='customer-invalid-message'>
                    <FormattedMessage id='CUSTOMER_INVALID'/>
                </span>
                }
                <CustomerSearch2Modal
                    customer={props.customer}
                    isOpen={props.customerSearchModal}
                    onClose={props.onCustomerSearchClick}
                    onCustomerCreate={props.onCreateCustomerClick}
                />

            </div> :
            <div>
                {props.customer.displayName ?
                    <span className='customer-name'>
                        {props.customer.displayName}
                    </span> : null
                }
            </div>
        }
    </div>;

CustomerSearchField.displayName = 'CustomerSearchField';
CustomerSearchField.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired,
    customerSearchModal: PropTypes.bool.isRequired,
    isCustomerEditable: PropTypes.bool.isRequired,
    isCustomerInvalid: PropTypes.bool.isRequired,
    isMachineAlreadyRegistered: PropTypes.bool.isRequired,
    onCreateCustomerClick: PropTypes.func.isRequired,
    onCustomerKeyPress: PropTypes.func.isRequired,
    onCustomerSearchClick: PropTypes.func.isRequired,
    showCustomerSearchIcon: PropTypes.bool.isRequired
};

export default CustomerSearchField;

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/product/product-registration/components/product-registration-form/customer-search-field.js